import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/Users/martina/Desktop/stg-temp-0106v2/components/site-header.tsx");
